import React, {useEffect, useRef, useState} from 'react';
import {withTranslation} from 'react-i18next';
import './multipleChoiceOptions.css';

export const MultipleChoiceOptions = ({options, questionId, onOptionsChanged, t}) => {
  const [values, setValues] = useState(() => options.options || [`${t('Option')} 1`]);
  const nextFocus = useRef(null);

  useEffect(() => {
    setValues(options.options || [`${t('Option')} 1`]);
  }, [options]);

  useEffect(() => {
    if (nextFocus.current === null) return;
    const input = document.getElementById(`${questionId}-${nextFocus.current}`);
    input?.focus();
    input?.select();
    nextFocus.current = null;
  }, [values.length, questionId]);

  const publish = updatedOptions => {
    setValues(updatedOptions);
    onOptionsChanged({
      options: updatedOptions,
      minSelected: 1,
      maxSelected: 1
    });
  };

  const changeOption = (index, value) => {
    const updatedOptions = [...values];
    updatedOptions[index] = value;
    publish(updatedOptions);
  };

  const addOption = () => {
    nextFocus.current = values.length;
    publish([...values, `${t('Option')} ${values.length + 1}`]);
  };

  const removeOption = index => publish(values.filter((_, optionIndex) => optionIndex !== index));

  return <div className="br-survey-option-editor">
    {values.map((option, index) => <div className="br-survey-option-editor__row" key={index}>
      <span aria-hidden="true" className="br-survey-option-editor__marker">○</span>
      <input id={`${questionId}-${index}`} type="text" value={option}
        aria-label={`${t('Option')} ${index + 1}`}
        onChange={event => changeOption(index, event.target.value)} />
      {values.length > 1 && <button type="button" aria-label={`${t('Remove')} ${t('Option')} ${index + 1}`}
        onClick={() => removeOption(index)}>×</button>}
    </div>)}
    <button className="br-survey-option-editor__add" type="button" onClick={addOption}>
      {t('Add')} {t('Option')}
    </button>
  </div>;
};

export default withTranslation()(MultipleChoiceOptions);
